import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

export const transformErrorResponse = (response: FetchBaseQueryError) => {
    const status = response.status === 'PARSING_ERROR' ? response.originalStatus : response.status;
    return {
        status: status,
    };
};
